var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfContainer"},[_c('div',{staticClass:"pdfLeft"},[_c('img',{staticClass:"pdfimg",attrs:{"src":require("../../assets/img/pdf_icon.png"),"alt":""}}),_vm._v(" "),_c('p',{on:{"click":_vm.clickbtn}},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6a86024","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title/cPdfTitle.vue
// module id = null
// module chunks = 